/* Khuwabb theme — global behavior. No framework, no build step. */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.getElementById('MobileMenu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isOpen = !mobileMenu.hidden;
      mobileMenu.hidden = isOpen;
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ---------- Search panel ---------- */
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.querySelector('[data-search-panel]');
      if (!panel) return;
      panel.hidden = !panel.hidden;
      if (!panel.hidden) {
        var input = panel.querySelector('[data-search-input]');
        if (input) input.focus();
      }
    });
  });

  /* ---------- Announcement bar carousel ---------- */
  (function announcementCarousel() {
    var track = document.querySelector('[data-announcement-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.announcement-bar__slide');
    if (slides.length < 2) {
      if (slides[0]) slides[0].classList.add('is-active');
      return;
    }
    var index = 0;
    slides[0].classList.add('is-active');

    function show(i) {
      slides[index].classList.remove('is-active');
      index = (i + slides.length) % slides.length;
      slides[index].classList.add('is-active');
    }
    var prev = document.querySelector('[data-announcement-prev]');
    var next = document.querySelector('[data-announcement-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    setInterval(function () { show(index + 1); }, 5000);
  })();

  /* ---------- Quantity steppers (generic) ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-quantity-minus]');
    var plus = e.target.closest('[data-quantity-plus]');
    if (minus || plus) {
      var wrap = (minus || plus).closest('.quantity-stepper');
      var input = wrap && wrap.querySelector('[data-quantity-input]');
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        input.value = plus ? val + 1 : Math.max(1, val - 1);
      }
    }
  });

  /* ---------- Variant picker (product page) ---------- */
  (function variantPicker() {
    var form = document.getElementById('ProductForm');
    if (!form) return;

    var scriptTag = document.querySelector('[data-product-json]');
    var product = scriptTag ? JSON.parse(scriptTag.textContent) : null;
    var variantIdInput = form.querySelector('[data-variant-id]');
    var selected = {};

    form.querySelectorAll('.swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var optionIndex = swatch.getAttribute('data-option-index');
        var value = swatch.getAttribute('data-option-value');
        selected[optionIndex] = value;

        form.querySelectorAll('[data-option-index="' + optionIndex + '"].swatch').forEach(function (s) {
          s.classList.toggle('is-selected', s === swatch);
        });

        if (!product) return;
        var match = product.variants.find(function (v) {
          return ['option1', 'option2', 'option3'].every(function (key, i) {
            return selected[i] === undefined || v[key] === selected[i];
          });
        });
        if (match && variantIdInput) {
          variantIdInput.value = match.id;
          var priceEl = document.querySelector('.product-detail .price__regular, .product-detail .price__sale');
          if (priceEl) priceEl.textContent = formatMoney(match.price);
          var addBtn = document.querySelector('[data-add-to-cart]');
          var addText = document.querySelector('[data-add-to-cart-text]');
          if (addBtn) addBtn.disabled = !match.available;
          if (addText) addText.textContent = match.available ? 'Add to cart' : 'Sold out';
        }
      });
    });

    /* Gallery thumbs */
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-media-id');
        document.querySelectorAll('[data-gallery] .product-detail__gallery-item').forEach(function (item) {
          item.classList.toggle('is-active', item.getAttribute('data-media-id') === id);
        });
        document.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });

    /* Add to cart via AJAX so the drawer can open without a full reload */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { refreshCartDrawer(true); })
        .catch(function () { form.submit(); });
    });
  })();

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.getElementById('CartDrawer');

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.hidden = false;
  }
  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.hidden = true;
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', openCartDrawer);
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) closeCartDrawer();
  });

  function refreshCartDrawer(openAfter) {
    fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawer');
        if (fresh && cartDrawer) {
          cartDrawer.innerHTML = fresh.innerHTML;
          updateCartCount();
        }
        if (openAfter) openCartDrawer();
      });
  }

  window.refreshCartDrawer = refreshCartDrawer;

  function updateCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    });
  }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-cart-qty-minus]');
    var plus = e.target.closest('[data-cart-qty-plus]');
    var remove = e.target.closest('[data-cart-remove]');
    if (minus || plus || remove) {
      var line = (minus || plus || remove).getAttribute('data-line');
      var qtyValueEl = document.querySelector('.cart-drawer__item[data-line="' + line + '"] [data-cart-qty-value]');
      var current = qtyValueEl ? parseInt(qtyValueEl.textContent, 10) : null;
      var newQty = remove ? 0 : (plus ? (current || 1) + 1 : Math.max(0, (current || 1) - 1));

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: newQty })
      })
        .then(function () { refreshCartDrawer(false); })
        .catch(function () {});
    }
  });

  updateCartCount();

  /* ---------- Wishlist (localStorage, per-browser) ---------- */
  var WISHLIST_KEY = 'khuwabb:wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function updateWishlistUI() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.classList.toggle('is-active', list.indexOf(id) !== -1);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-wishlist-toggle]');
    if (!toggle) return;
    var id = toggle.getAttribute('data-product-id');
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx === -1) list.push(id); else list.splice(idx, 1);
    setWishlist(list);
    updateWishlistUI();
  });

  updateWishlistUI();

  /* ---------- Quick view ---------- */
  var quickView = document.getElementById('QuickView');

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-quick-view-open]');
    if (!opener || !quickView) return;
    e.preventDefault();
    var url = opener.getAttribute('data-product-url');

    quickView.innerHTML = '<div class="quick-view-drawer__panel"><p>Loading…</p></div>';
    quickView.hidden = false;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('.product-detail__grid');
        quickView.innerHTML =
          '<div class="quick-view-drawer__panel">' +
          '<button type="button" class="icon-button quick-view-drawer__close" data-quick-view-close aria-label="Close">&times;</button>' +
          '<div class="product-detail__grid">' + (content ? content.innerHTML : '') + '</div>' +
          '</div>';
      });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-quick-view-close]') || e.target === quickView) {
      if (quickView) quickView.hidden = true;
    }
  });

  /* ---------- Collection filters + sort ---------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  document.querySelectorAll('[data-filter-param]').forEach(function (input) {
    input.addEventListener('change', function () {
      var url = new URL(window.location.href);
      if (input.checked) url.searchParams.append(input.getAttribute('data-filter-param'), input.value);
      else {
        var values = url.searchParams.getAll(input.getAttribute('data-filter-param')).filter(function (v) { return v !== input.value; });
        url.searchParams.delete(input.getAttribute('data-filter-param'));
        values.forEach(function (v) { url.searchParams.append(input.getAttribute('data-filter-param'), v); });
      }
      window.location.href = url.toString();
    });
  });

  var filtersToggle = document.querySelector('[data-filters-toggle]');
  var filtersPanel = document.querySelector('[data-filters]');
  if (filtersToggle && filtersPanel) {
    filtersToggle.addEventListener('click', function () {
      filtersPanel.classList.toggle('is-open');
    });
  }

  var clearFilters = document.querySelector('[data-filters-clear]');
  if (clearFilters) {
    clearFilters.addEventListener('click', function () {
      var url = new URL(window.location.href);
      var base = url.pathname + (url.searchParams.has('sort_by') ? '?sort_by=' + url.searchParams.get('sort_by') : '');
      window.location.href = base;
    });
  }

  /* ---------- Testimonial dots ---------- */
  document.querySelectorAll('[data-testimonial-dots]').forEach(function (dots) {
    var section = dots.closest('section');
    var cards = section.querySelectorAll('.testimonial-card');
    dots.querySelectorAll('[data-testimonial-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);
        cards.forEach(function (c, i) { c.classList.toggle('is-active', i === index); });
        dots.querySelectorAll('[data-testimonial-dot]').forEach(function (d) { d.classList.toggle('is-active', d === dot); });
      });
    });
  });

  /* ---------- Countdown timer ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown').replace(' ', 'T'));
    if (isNaN(target.getTime())) return;

    var daysEl = el.querySelector('[data-countdown-days]');
    var hoursEl = el.querySelector('[data-countdown-hours]');
    var minsEl = el.querySelector('[data-countdown-minutes]');
    var secsEl = el.querySelector('[data-countdown-seconds]');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = target.getTime() - Date.now();
      if (diff <= 0) {
        [daysEl, hoursEl, minsEl, secsEl].forEach(function (e) { if (e) e.textContent = '00'; });
        clearInterval(timer);
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---------- Bundle builder ---------- */
  document.querySelectorAll('[data-bundle-builder]').forEach(function (builder) {
    var section = builder.closest('section');
    var totalEl = section.querySelector('[data-bundle-total]');
    var addBtn = section.querySelector('[data-bundle-add-all]');

    function currentCents() {
      var total = 0;
      builder.querySelectorAll('[data-bundle-slot]').forEach(function (slot) {
        var checked = slot.querySelector('input[type="radio"]:checked');
        if (checked && checked.value) total += parseInt(checked.getAttribute('data-bundle-price'), 10) || 0;
      });
      return total;
    }
    function refreshTotal() {
      if (totalEl) totalEl.textContent = formatMoney(currentCents());
    }
    builder.addEventListener('change', refreshTotal);
    refreshTotal();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        builder.querySelectorAll('[data-bundle-slot]').forEach(function (slot) {
          var checked = slot.querySelector('input[type="radio"]:checked');
          if (checked && checked.value) items.push({ id: parseInt(checked.value, 10), quantity: 1 });
        });
        if (items.length === 0) return;

        addBtn.disabled = true;
        var originalText = addBtn.textContent;
        addBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            refreshCartDrawer(true);
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          })
          .catch(function () {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          });
      });
    }
  });

  /* ---------- Native product recommendations (Shopify's recommendation engine) ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  /* ---------- Predictive search (live results as you type) ---------- */
  (function predictiveSearch() {
    var input = document.querySelector('[data-search-input]');
    var results = document.querySelector('[data-search-results]');
    if (!input || !results) return;

    var debounceTimer;
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var term = input.value.trim();
      if (term.length < 2) { results.innerHTML = ''; return; }

      debounceTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length === 0) {
              results.innerHTML = '<p class="predictive-search__empty">No matches yet — try a word like "bedsheet" or "towel".</p>';
              return;
            }
            results.innerHTML = products.map(function (p) {
              return '<a class="predictive-search__result" href="' + p.url + '">' +
                (p.featured_image ? '<img src="' + p.featured_image.url + '&width=100" alt="" width="48" height="48">' : '') +
                '<span>' + p.title + '</span>' +
                '<span class="predictive-search__price">' + p.price + '</span>' +
                '</a>';
            }).join('');
          })
          .catch(function () {});
      }, 250);
    });
  })();

  /* ---------- Product comparison tool ---------- */
  var COMPARE_KEY = 'khuwabb:compare';
  var MAX_COMPARE = 4;

  function getCompareList() {
    try { return JSON.parse(localStorage.getItem(COMPARE_KEY)) || []; }
    catch (e) { return []; }
  }
  function setCompareList(list) {
    try { localStorage.setItem(COMPARE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function renderCompareBar() {
    var list = getCompareList();
    var bar = document.getElementById('CompareBar');
    if (!bar) return;
    bar.hidden = list.length === 0;
    var countEl = bar.querySelector('[data-compare-count]');
    if (countEl) countEl.textContent = list.length;

    document.querySelectorAll('[data-compare-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.classList.toggle('is-active', list.indexOf(id) !== -1);
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-compare-toggle]');
    if (toggle) {
      var id = toggle.getAttribute('data-product-id');
      var handle = toggle.getAttribute('data-product-handle');
      var list = getCompareList();
      var idx = list.findIndex(function (i) { return i.id === id; });
      if (idx === -1) {
        if (list.length >= MAX_COMPARE) { alert('You can compare up to ' + MAX_COMPARE + ' products at a time.'); return; }
        list.push({ id: id, handle: handle });
      } else {
        list.splice(idx, 1);
      }
      setCompareList(list);
      renderCompareBar();
      return;
    }

    if (e.target.closest('[data-compare-clear]')) {
      setCompareList([]);
      renderCompareBar();
      var modal = document.getElementById('CompareModal');
      if (modal) modal.hidden = true;
      return;
    }

    if (e.target.closest('[data-compare-open]')) {
      openCompareModal();
      return;
    }

    if (e.target.closest('[data-compare-close]')) {
      var modal2 = document.getElementById('CompareModal');
      if (modal2) modal2.hidden = true;
    }
  });

  function openCompareModal() {
    var modal = document.getElementById('CompareModal');
    var body = modal && modal.querySelector('[data-compare-body]');
    if (!modal || !body) return;
    var list = getCompareList();

    body.innerHTML = '<p>Loading…</p>';
    modal.hidden = false;

    Promise.all(list.map(function (item) {
      return fetch('/products/' + item.handle + '.js').then(function (r) { return r.json(); });
    })).then(function (products) {
      if (products.length === 0) {
        body.innerHTML = '<p>Nothing to compare yet — tap the compare icon on a few products first.</p>';
        return;
      }
      var table = '<table class="compare-table"><thead><tr><th></th>' +
        products.map(function (p) { return '<th>' + p.title + '</th>'; }).join('') +
        '</tr></thead><tbody>';

      table += '<tr><td>Image</td>' + products.map(function (p) {
        var img = p.featured_image ? p.featured_image : (p.images && p.images[0]);
        return '<td>' + (img ? '<img src="' + img + '&width=160" alt="" width="80" height="80">' : '') + '</td>';
      }).join('') + '</tr>';

      table += '<tr><td>Price</td>' + products.map(function (p) {
        return '<td>' + formatMoney(p.price) + '</td>';
      }).join('') + '</tr>';

      table += '<tr><td>Vendor</td>' + products.map(function (p) {
        return '<td>' + (p.vendor || '—') + '</td>';
      }).join('') + '</tr>';

      table += '<tr><td>Availability</td>' + products.map(function (p) {
        return '<td>' + (p.available ? 'In stock' : 'Sold out') + '</td>';
      }).join('') + '</tr>';

      table += '</tbody></table>';
      body.innerHTML = table;
    });
  }

  renderCompareBar();

  /* ---------- Scroll reveal (single deliberate entrance, not per-card) ---------- */
  if (document.body.dataset.animations !== 'off' && 'IntersectionObserver' in window) {
    var revealTargets = document.querySelectorAll('.hero__content, .hero__media, .countdown-banner__content');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    revealTargets.forEach(function (t) { observer.observe(t); });
  }

  /* ---------- Slideshow ---------- */
  document.querySelectorAll('[data-slideshow-track]').forEach(function (track) {
    var section = track.closest('section');
    var slides = track.querySelectorAll('.slideshow__slide');
    if (slides.length < 2) return;
    var index = 0;
    var autoplay = section.dataset.autoplay !== 'false';

    function show(i) {
      slides[index].classList.remove('is-active');
      index = (i + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      section.querySelectorAll('[data-slideshow-dot]').forEach(function (d, di) {
        d.classList.toggle('is-active', di === index);
      });
    }
    var prev = section.querySelector('[data-slideshow-prev]');
    var next = section.querySelector('[data-slideshow-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    section.querySelectorAll('[data-slideshow-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () { show(parseInt(dot.getAttribute('data-index'), 10)); });
    });
    if (autoplay) setInterval(function () { show(index + 1); }, 6000);
  });

  /* ---------- Mobile sticky add-to-cart bar ---------- */
  var stickyBar = document.querySelector('[data-mobile-sticky-bar]');
  if (stickyBar) {
    var mainForm = document.getElementById('ProductForm');
    var revealAt = document.querySelector('.product-detail__accordion') || document.querySelector('.product-form');

    function toggleSticky() {
      if (!revealAt) return;
      var rect = revealAt.getBoundingClientRect();
      stickyBar.hidden = window.innerWidth > 767 || rect.top > window.innerHeight;
    }
    window.addEventListener('scroll', toggleSticky, { passive: true });
    window.addEventListener('resize', toggleSticky);
    toggleSticky();

    var stickyAdd = stickyBar.querySelector('[data-mobile-sticky-add]');
    if (stickyAdd && mainForm) {
      stickyAdd.addEventListener('click', function () {
        mainForm.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  }

  /* ---------- Recently viewed products (localStorage) ---------- */
  (function recentlyViewed() {
    var RECENT_KEY = 'khuwabb:recent';
    var MAX_RECENT = 8;

    function getRecent() {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; }
      catch (e) { return []; }
    }
    function setRecent(list) {
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
    }

    var currentHandle = document.body.getAttribute('data-product-handle');
    if (currentHandle) {
      var list = getRecent().filter(function (h) { return h !== currentHandle; });
      list.unshift(currentHandle);
      setRecent(list.slice(0, MAX_RECENT));
    }

    var section = document.querySelector('[data-recently-viewed]');
    if (!section) return;
    var grid = section.querySelector('[data-recently-viewed-grid]');
    var handles = getRecent().filter(function (h) { return h !== currentHandle; }).slice(0, 4);
    if (handles.length === 0) return;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (products.length === 0) return;
      grid.innerHTML = products.map(function (p) {
        var img = p.featured_image ? p.featured_image : (p.images && p.images[0]);
        return '<div class="product-card"><a class="product-card__media-link" href="' + p.url + '">' +
          '<div class="product-card__media">' + (img ? '<img src="' + img + '&width=600" alt="" loading="lazy">' : '') + '</div>' +
          '</a><div class="product-card__info"><h3 class="product-card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
          '<div class="price"><span class="price__regular">' + formatMoney(p.price) + '</span></div></div></div>';
      }).join('');
      section.hidden = false;
    });
  })();

  /* ---------- Quick order list ---------- */
  var quickOrderForm = document.querySelector('[data-quick-order-form]');
  if (quickOrderForm) {
    var quickOrderAdd = quickOrderForm.querySelector('[data-quick-order-add]');
    if (quickOrderAdd) {
      quickOrderAdd.addEventListener('click', function () {
        var items = [];
        quickOrderForm.querySelectorAll('[data-quantity-input]').forEach(function (input) {
          var qty = parseInt(input.value, 10) || 0;
          if (qty > 0) items.push({ id: parseInt(input.getAttribute('data-variant-id'), 10), quantity: qty });
        });
        if (items.length === 0) return;
        quickOrderAdd.disabled = true;
        var original = quickOrderAdd.textContent;
        quickOrderAdd.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function () { refreshCartDrawer(true); quickOrderAdd.textContent = original; quickOrderAdd.disabled = false; })
          .catch(function () { quickOrderAdd.textContent = original; quickOrderAdd.disabled = false; });
      });
    }
  }

  /* ---------- Collection tabs / banner tabs / tabs-content (shared pattern) ---------- */
  document.querySelectorAll('[data-collection-tabs-nav], [data-tabs-nav]').forEach(function (nav) {
    var section = nav.closest('section');
    if (!section) return;
    var isTabsContent = nav.hasAttribute('data-tabs-nav');
    var buttonSelector = isTabsContent ? '[data-tab-button]' : '[data-collection-tab]';
    var panelSelector = isTabsContent ? '[data-tab-panel]' : '[data-collection-tab-panel]';

    nav.querySelectorAll(buttonSelector).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.getAttribute('data-index');
        nav.querySelectorAll(buttonSelector).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        section.querySelectorAll(panelSelector).forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-index') === index);
        });
      });
    });
  });

  /* ---------- Image comparison slider ---------- */
  document.querySelectorAll('[data-image-compare]').forEach(function (wrap) {
    var range = wrap.querySelector('[data-image-compare-range]');
    var after = wrap.querySelector('[data-image-compare-after]');
    if (!range || !after) return;
    range.addEventListener('input', function () {
      after.style.clipPath = 'inset(0 ' + (100 - range.value) + '% 0 0)';
    });
  });

  /* ---------- Lookbook hotspots ---------- */
  document.querySelectorAll('[data-lookbook-hotspot]').forEach(function (hotspot) {
    hotspot.addEventListener('click', function () {
      var url = hotspot.getAttribute('data-product-url');
      if (url) window.location.href = url;
    });
  });

  /* ---------- Popup (delayed, session-based) ---------- */
  document.querySelectorAll('[data-site-popup]').forEach(function (popup) {
    var seenKey = 'khuwabb:popup-seen:' + popup.id;
    var frequency = popup.getAttribute('data-frequency');
    var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 6) * 1000;

    var alreadySeen = frequency === 'session' && sessionStorage.getItem(seenKey);
    if (alreadySeen) return;

    setTimeout(function () {
      popup.hidden = false;
      sessionStorage.setItem(seenKey, '1');
    }, delay);

    popup.querySelectorAll('[data-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { popup.hidden = true; });
    });
  });

  /* ---------- Favorites (wishlist) page ---------- */
  (function favoritesPage() {
    var grid = document.querySelector('[data-favorites-grid]');
    if (!grid) return;
    var WISHLIST_KEY = 'khuwabb:wishlist';
    var ids = [];
    try { ids = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) {}

    if (ids.length === 0) {
      grid.innerHTML = '<p class="favorites-page__empty">Nothing saved yet — tap the heart icon on any product to add it here.</p>';
      return;
    }

    fetch('/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.products || []).filter(function (p) { return ids.indexOf(String(p.id)) !== -1; });
        if (products.length === 0) {
          grid.innerHTML = '<p class="favorites-page__empty">Nothing saved yet — tap the heart icon on any product to add it here.</p>';
          return;
        }
        grid.innerHTML = products.map(function (p) {
          var img = p.images && p.images[0];
          var price = p.variants && p.variants[0] ? p.variants[0].price : '';
          return '<div class="product-card"><a class="product-card__media-link" href="/products/' + p.handle + '">' +
            '<div class="product-card__media">' + (img ? '<img src="' + img.src + '" alt="" loading="lazy">' : '') + '</div>' +
            '</a><div class="product-card__info"><h3 class="product-card__title"><a href="/products/' + p.handle + '">' + p.title + '</a></h3>' +
            '<div class="price"><span class="price__regular">Rs. ' + price + '</span></div></div></div>';
        }).join('');
      })
      .catch(function () {
        grid.innerHTML = '<p class="favorites-page__empty">Could not load your wishlist right now.</p>';
      });
  })();

  /* ---------- Page load veil (single orchestrated entrance) ---------- */
  var veil = document.querySelector('[data-page-veil]');
  if (veil) {
    window.addEventListener('load', function () {
      setTimeout(function () { veil.classList.add('is-hidden'); }, 250);
    });
    // Fallback in case load already fired or is slow
    setTimeout(function () { veil.classList.add('is-hidden'); }, 1800);
  }

  /* ---------- Sticky header shrink on scroll ---------- */
  var siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    var onHeaderScroll = function () {
      siteHeader.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  /* ---------- Hero cursor spotlight ---------- */
  document.querySelectorAll('[data-hero-spotlight]').forEach(function (hero) {
    hero.addEventListener('mousemove', function (e) {
      var rect = hero.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      hero.style.setProperty('--spot-x', x + '%');
      hero.style.setProperty('--spot-y', y + '%');
    });
  });

  /* ---------- Magnetic primary buttons (subtle, premium) ---------- */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.button--primary').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var x = (e.clientX - rect.left - rect.width / 2) * 0.15;
        var y = (e.clientY - rect.top - rect.height / 2) * 0.3;
        btn.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---------- Staggered grid reveal (one system, applied consistently) ---------- */
  if (document.body.dataset.animations !== 'off' && 'IntersectionObserver' in window) {
    var groupObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          groupObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('[data-reveal-group]').forEach(function (g) { groupObserver.observe(g); });
  }

  /* ---------- Animated stat counters (hero specs) ---------- */
  if ('IntersectionObserver' in window) {
    var counterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.querySelectorAll('.hero__spec dt').forEach(function (dt) {
          var text = dt.textContent.trim();
          var match = text.match(/^([\d.]+)(.*)$/);
          if (!match) return;
          var target = parseFloat(match[1]);
          var suffix = match[2];
          var start = performance.now();
          var duration = 900;
          function tick(now) {
            var progress = Math.min((now - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var value = target < 10 ? (target * eased).toFixed(1) : Math.round(target * eased);
            dt.textContent = value + suffix;
            if (progress < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
        });
        counterObserver.unobserve(entry.target);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('.hero__specs').forEach(function (el) { counterObserver.observe(el); });
  }

  /* ---------- Floating mini add-to-cart bar (shows once main buy box scrolls out of view) ---------- */
  var floatingBar = document.querySelector('[data-floating-add-bar]');
  var buybox = document.querySelector('[data-buybox]');
  if (floatingBar && buybox && 'IntersectionObserver' in window) {
    var floatingObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        floatingBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    floatingObserver.observe(buybox);

    var floatingAddBtn = floatingBar.querySelector('[data-floating-add]');
    var mainForm = document.getElementById('ProductForm');
    if (floatingAddBtn && mainForm) {
      floatingAddBtn.addEventListener('click', function () {
        mainForm.dispatchEvent(new Event('submit', { cancelable: true }));
        buybox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* ---------- Compact cross-sell row "Add" buttons ---------- */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-cross-sell-add]');
    if (!addBtn) return;
    var variantId = addBtn.getAttribute('data-variant-id');
    if (!variantId) return;
    var original = addBtn.textContent;
    addBtn.textContent = 'Adding…';
    addBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function () { refreshCartDrawer(true); addBtn.textContent = original; addBtn.disabled = false; })
      .catch(function () { addBtn.textContent = original; addBtn.disabled = false; });
  });
});
